import { render, staticRenderFns } from "./KawaiiSentMessage.vue?vue&type=template&id=71840274&scoped=true&"
import script from "./KawaiiSentMessage.vue?vue&type=script&lang=ts&"
export * from "./KawaiiSentMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71840274",
  null
  
)

export default component.exports